import { Card } from 'react-bootstrap-5';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';
import DownloadCaLink from './download_ca_link';

export const STEP_TEXTS = {
  'custom_word': {
    step2: 'Annotate the CA using the document editor of your choice',
    step3: 'Upload your edited document here',
    step3Dragging: 'Drop your edited document here',
    downloadText: 'Download .docx'
  },
  'custom_pdf': {
    step2: 'Sign the CA electronically with Adobe or your PDF software of choice',
    step3: 'Upload your signed document here',
    step3Dragging: 'Drop your signed document here',
    downloadText: 'Download PDF'
  },
  'both': {
    step2: 'Annotate or sign the CA using the document editor or PDF software of your choice',
    step3: 'Upload your edited or signed document here',
    step3Dragging: 'Drop your edited or signed document here'
  }
};

export default function PdfCa({ caFiles, uploadedFile, onFileUploaded }) {
  const onDrop = useCallback((acceptedFiles) => {
    onFileUploaded(acceptedFiles[0]);
  }, []);

  const acceptedFileTypes = caFiles.map((caFile) => {
    if (caFile.type === 'custom_word') return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    if (caFile.type === 'custom_pdf') return 'application/pdf';
    return null;
  }).filter(n => n);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptedFileTypes,
    maxFiles: 1
  });

  const parseStepText = step => STEP_TEXTS[caFiles.length > 1 ? 'both' : caFiles[0].type]?.[step];

  return (
    <React.Fragment>
      <div className="mb-4 text-center">
        <h5 className="mb-2">
          <strong>Step 1</strong>
        </h5>
        <div>Download the CA using the following link</div>
        <div className="d-flex justify-content-center mt-2 gap-2">
          {caFiles.map(({ path, type }) => (
            <DownloadCaLink
              href={path}
              key={path}
              label={STEP_TEXTS[type].downloadText}
            />
          ))}
        </div>
      </div>
      <div className="mb-4 text-center">
        <h5 className="mb-2">
          <strong>Step 2</strong>
        </h5>
        <div name="step2">{parseStepText('step2')}</div>
      </div>
      <div className="mb-4 text-center">
        <h5 className="mb-2">
          <strong>Step 3</strong>
        </h5>
        <Card className="clickable" {...getRootProps()} style={{ borderStyle: 'dashed' }}>
          <Card.Body className="p-4">
            <input {...getInputProps()} />
            {isDragActive && <div name="step3Dragging">{parseStepText('step3Dragging')}</div>}
            {!isDragActive && !uploadedFile && <div name="step3">{parseStepText('step3')}</div>}
            {!isDragActive && uploadedFile && (
              <div>
                <div>Uploaded <strong>{uploadedFile.name}</strong></div>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    </React.Fragment>
  );
}

PdfCa.propTypes = {
  caFiles: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['custom_pdf', 'custom_word']).isRequired,
    path: PropTypes.string.isRequired,
  })).isRequired,
  uploadedFile: PropTypes.object,
  onFileUploaded: PropTypes.func.isRequired
};
